import { render, staticRenderFns } from "./zxyhd.vue?vue&type=template&id=b2486628&scoped=true&"
import script from "./zxyhd.vue?vue&type=script&lang=js&"
export * from "./zxyhd.vue?vue&type=script&lang=js&"
import style0 from "./zxyhd.vue?vue&type=style&index=0&id=b2486628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2486628",
  null
  
)

export default component.exports